// @flow
import * as React from 'react';
import styled from 'styled-components';
import theme from 'styled-theming';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Typography from '../Common/Typography';
import { Button } from '../Common/Button';
import StyledModal from './StyledModal';

type Kind = 'success' | 'info' | 'danger';

const iconColor = theme.variants('mode', 'kind', {
  info: { light: '#3498DB', dark: '#9933cc' },
  success: { light: '#28a745', dark: '#77b300' },
  danger: { light: '#dc3545', dark: '#cc0000' }
});

const Icon = styled(FontAwesomeIcon)`
  color: ${iconColor};
`;

const NotificationModal = (props: {
  title: string,
  message: string,
  kind: Kind,
  icon: string | Array<string>,
  onRequestClose: () => void
}) => (
  <StyledModal isOpen onRequestClose={props.onRequestClose}>
    <Typography kind="h1">{props.title}</Typography>
    <Icon kind={props.kind} icon={props.icon} size="5x" />
    <p>{props.message}</p>
    <Button kind="secondary" onClick={props.onRequestClose}>
      OK
    </Button>
  </StyledModal>
);

NotificationModal.defaultProps = {
  kind: 'info',
  icon: 'info-circle'
};

export default NotificationModal;
